import React, {useEffect, useState} from 'react';
import { getUploadedImages } from '../../services/apiService';
import { Box, Typography, IconButton } from '@mui/material';
import Masonry from "react-masonry-css";
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';

function ExistingUploadImages({modelId, setImage, setPrompt, setForm, setUpload, image, upload}: any) {
    const [uploadExistingImages, setUploadExistingImages] = useState<any[]>([]);
    const userId = localStorage.getItem("userId") || "";
    const [viewType, setViewType] = useState<'grid' | 'masonry'>('masonry');

   const uploadedAllExistingImages = React.useCallback(async () => {
     try {
       const response: any = await getUploadedImages(userId, modelId);
       if (response) {
         setUploadExistingImages((prev: any) => {
           const existingIds = new Set(prev.map((img:any) => img.id || img.url));
           const uniqueNewImages = response.filter(
             (img:any) => !existingIds.has(img.id || img.url)
           );
           return [...uniqueNewImages, ...prev];
         });
       } else {
         console.error("No data found in the response.");
       }
     } catch (error) {
       console.error("Error uploading file:", error);
     }
   }, [userId, modelId]);

   useEffect(()=>{
        if (userId && modelId) {
        uploadedAllExistingImages();
        }
   }, [userId, modelId, uploadedAllExistingImages, image, upload]);

   const handleDragStart = (event: React.DragEvent<HTMLImageElement>, image: any) => {
     // Pass image data as JSON string
     event.dataTransfer.setData('application/json', JSON.stringify(image));
     // Optionally, set drag effect
     event.dataTransfer.effectAllowed = 'copy';
   }

  return (
    <Box sx={{width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <Typography variant="h6" gutterBottom className='subTitle'>
          Uploaded Images
        </Typography>
        <div>
          {viewType === 'grid' ? (
            <IconButton onClick={() => setViewType('masonry')} color="default">
              <ViewQuiltIcon />
            </IconButton>
          ) : (
            <IconButton onClick={() => setViewType('grid')} color="default">
              <ViewModuleIcon />
            </IconButton>
          )}
        </div>
      </div>
      {uploadExistingImages.length > 0 ? (
        viewType === 'grid' ? (
          <Box className='uploaded-images-grid'>
            <Box sx={{ flexGrow: 1 }}>
              <Box component={"div"} sx={{ width: '100%' }}>
                <Box component={"div"} sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  {/* Responsive grid using MUI Grid */}
                  <Box sx={{ width: '100%' }}>
                    <Box component={"div"} sx={{ display: 'grid', gridTemplateColumns: {
                      xs: 'repeat(1, 1fr)',
                      sm: 'repeat(2, 1fr)',
                      md: 'repeat(3, 1fr)',
                      xl: 'repeat(4, 1fr)'
                    }, gap: '10px' }}>
                      {uploadExistingImages.map((image: any) => (
                        <Box key={image.id || image.url}>
                          <img
                            src={image.url}
                            alt={image.caption || "Uploaded Image"}
                            style={{ width: '100%', height: '100px', objectFit: 'cover', borderRadius: '8px' }}
                            draggable={true}
                            onDragStart={e => handleDragStart(e, image)}
                          />
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : (
          <Masonry 
            breakpointCols={{ default: 4, 1100: 4, 700: 3, 500: 3, 300: 1 }}
            className="my-masonry-grids"
            columnClassName="my-masonry-grid_column"
            >
            {uploadExistingImages.map((image: any) => (
              <img
                key={image.id || image.url}
                src={image.url}
                alt={image.caption || "Uploaded Image"}
                style={{ width: '100%', display: 'block', borderRadius: '8px', marginBottom: '8px' }}
                draggable={true}
                onDragStart={e => handleDragStart(e, image)}
              />
            ))}
          </Masonry>
        )
      ) : (
        <Typography variant="body2" color="subTitle">
          No images uploaded yet.
        </Typography>
      )}
    </Box>
  )
}

export default ExistingUploadImages;